import {
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthStore, UserRole } from '../../core';

@Directive({
  selector: '[appHasRole]',
})
export class HasRoleDirective {
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly authStore = inject(AuthStore);

  readonly appHasRole = input.required<UserRole | UserRole[]>();

  private hasView = false;

  constructor() {
    effect(() => {
      const roles = this.appHasRole();
      const allowedRoles = Array.isArray(roles) ? roles : [roles];
      const hasRole = this.authStore.hasAnyRole(allowedRoles);

      if (hasRole && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!hasRole && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
